<template>
  <div v-if="value" class="flex items-center justify-center gap-x-2">
    <span
      v-for="item in [1, 2, 3, 4]"
      :key="item"
      class="h-2.5 w-2.5 animate-spinner-dots rounded-full bg-azure"
      :class="delays[item]"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  value?: boolean;
}
const delays: Record<any, any> = {
  1: 'animation-delay-0',
  2: 'animation-delay-[200ms]',
  3: 'animation-delay-[400ms]',
  4: 'animation-delay-[600ms]',
};

defineProps<Props>();
</script>
